import { Bucket } from "../../onethreefive/model/Bucket";
export class Slot {
    static createSlot(index, listName, tid = null, added = null, title = null, status = undefined, headerTitle = undefined, checkListItemId = "", type = "TodoTask", webLink = undefined, recurring = false) {
        let name;
        switch (index) {
            case 0:
                name = "slot1";
                break;
            case 1:
            case 2:
            case 3:
                name = ("slot3" + index);
                break;
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                name = ("slot5" + (index - 3));
                break;
            default:
                throw Error("Logic Error, slot index has to be [0-8]");
        }
        return new Slot({ name, tid, added, title, status, headerTitle, checkListItemId, type, webLink, listName, recurring });
    }
    static copySlot(slot) {
        return new Slot(slot);
    }
    constructor(s) {
        this.name = s.name;
        this.tid = s.tid;
        this.added = s.added;
        this.title = s.title;
        this.status = s.status;
        this.headerTitle = s.headerTitle;
        this.checkListItemId = s.checkListItemId;
        this.type = s.type;
        this.webLink = s.webLink;
        this.listName = s.listName;
        this.recurring = s.recurring;
        this.dueDate = s.dueDate;
    }
    getAdded() {
        return this.added;
    }
    getCategory() {
        switch (this.getBucket()) {
            case Bucket.ONE:
                return 'one';
            case Bucket.THREE:
                return 'three';
            case Bucket.FIVE:
                return 'five';
        }
    }
    getBucket() {
        if (this.name === 'slot1') {
            return Bucket.ONE;
        }
        else if (this.name.startsWith('slot3')) {
            return Bucket.THREE;
        }
        else if (this.name.startsWith('slot5')) {
            return Bucket.FIVE;
        }
        throw (new Error("Invalid Slot name"));
    }
    getCheckListItemId() {
        return this.checkListItemId;
    }
    getIndex() {
        const b = this.getBucket();
        switch (b) {
            case Bucket.ONE:
                return 0;
            case Bucket.THREE:
                return parseInt(this.name.charAt(this.name.length - 1));
            case Bucket.FIVE:
                return parseInt(this.name.charAt(this.name.length - 1)) + 3;
        }
    }
    getName() {
        return this.name;
    }
    getTaskId() {
        return this.tid;
    }
    object() {
        return JSON.parse(JSON.stringify(this));
    }
    isCheckListItem() {
        return this.checkListItemId != null && this.checkListItemId != "";
    }
    isComplete() {
        return this.status === 'completed';
    }
    isEmpty() {
        return this.tid == null;
    }
    reset() {
        this.tid = undefined;
        this.added = null;
        this.status = undefined;
        this.title = null;
    }
    // Example copy constructor or clone method
    static copyFrom(other) {
        return new Slot({
            name: other.name,
            tid: other.tid,
            added: other.added,
            title: other.title,
            status: other.status,
            headerTitle: other.headerTitle,
            checkListItemId: other.checkListItemId,
            type: other.type,
            webLink: other.webLink,
            listName: other.listName,
            recurring: other.recurring,
            dueDate: other.dueDate,
        });
    }
    // If you have a method like object() or toJSON()
    toJSON() {
        return {
            name: this.name,
            tid: this.tid,
            added: this.added,
            title: this.title,
            status: this.status,
            headerTitle: this.headerTitle,
            checkListItemId: this.checkListItemId,
            type: this.type,
            webLink: this.webLink,
            listName: this.listName,
            recurring: this.recurring,
            dueDate: this.dueDate,
        };
    }
    // If you have a fromObject or similar method
    static fromObject(obj) {
        return new Slot({
            name: obj.name,
            tid: obj.tid,
            added: obj.added,
            title: obj.title,
            status: obj.status,
            headerTitle: obj.headerTitle,
            checkListItemId: obj.checkListItemId,
            type: obj.type,
            webLink: obj.webLink,
            listName: obj.listName,
            recurring: obj.recurring,
            dueDate: obj.dueDate,
        });
    }
}
function applyMixins(derivedCtor, baseCtors) {
    baseCtors.forEach(baseCtor => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
            Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name) ||
                Object.create(null));
        });
    });
}
